import React from "react"
import { useParams } from "react-router-dom"

// components
import ProtocolMaintenance from "./subcomponents/ProtocolMaintenance/ProtocolMaintenance"
import ClinicalTrialsGov from "./subcomponents/ClinicalTrialsGov/ClinicalTrialsGov"
import { Flex } from "antd"

// styles
import "./Registries.scss"

// context
import { useGetStudy } from "api/hooks/studies/useStudiesApi"

// api
import { useGetStudyProtocolDataCompare, useGetStudyRegistryData } from "api/hooks/studies/useRegistries"

const Registries = () => {
  const { studyId } = useParams()
  const { data: study } = useGetStudy(studyId)
  const { data: registryData = [], refetch: refetchRegistryData } = useGetStudyRegistryData(study?.authoring_study_id)
  const { data: protocolDataCompare = [], refetch: refetchProtocolData } = useGetStudyProtocolDataCompare(
    study?.authoring_study_id
  )

  React.useEffect(() => {
    refetchRegistryData()
    refetchProtocolData()
  }, [])

  return (
    <Flex
      gap={12}
      style={{ width: "100%" }}
    >
      <ProtocolMaintenance
        study={study}
        protocolDataCompare={protocolDataCompare}
        clinicalTrialsData={registryData}
      />
      <ClinicalTrialsGov clinicalTrialsData={registryData} />
    </Flex>
  )
}

export default Registries
